var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { DependencyInjectionContext } from './DependencyInjectionContext';
export const DependencyInjectionProvider = ({ children, dependencies, }) => {
    return (_jsx(DependencyInjectionContext.Provider, { value: dependencies, children: children }));
};
_react_refresh_temp_1 = DependencyInjectionProvider;
$RefreshReg$(_react_refresh_temp_1, "DependencyInjectionProvider");
